import MerchantDefaultRoutes from 'pages/merchant/constants';
import DashboardRoutesList from 'pages/merchant/dashboard/constants';
import PaymentRoutesList from 'pages/merchant/dashboard/payment/constants';
import PayoutRoutesList from 'pages/merchant/dashboard/payout/constants';
import VirtualTerminalRoutesList from 'pages/merchant/dashboard/virtual-terminal/constants';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from 'redux/merchant/hooks';
import { getMerchantBaseUrl } from 'utils/getBaseUrl';
import { showZendeskWidget } from 'utils/zendesk';

import { Icon, Text } from '@limepayments/cosmic';

import SettingsDropdown from './SettingsDropdown';
import ToggleSidebar from './ToggleSidebar';

interface Props {
  activeTab?: string;
}

function Header({ activeTab }: Props) {
  const navigate = useNavigate();
  const { merchantName, merchantType } = useAppSelector((state) => ({
    merchantName: state.config.merchantName,
    merchantType: state.config.merchantType,
  }));

  const [isSettingOpened, setIsSettingOpened] = useState(false);

  function toggleSetting() {
    setIsSettingOpened((wasSettingOpened) => !wasSettingOpened);
  }

  return (
    <div className="container container-sm">
      <div className="header-main">
        <div className="header-main-inner">
          <div className="header-logo">
            <div className="avatar hoppy">
              <Text alignment="left" tagName="p" variant="body-3" isEmphasised>
                {merchantName.substring(0, 1).toUpperCase()}
              </Text>
            </div>
            <div className="header-logo-text">
              <Text alignment="left" tagName="p" variant="body-2" isEmphasised>
                {merchantName.length > 10
                  ? `${merchantName.substring(0, 4).toUpperCase()}...
                ${merchantName.slice(-3).toUpperCase()}`
                  : merchantName.toUpperCase()}
              </Text>
            </div>
          </div>
          <ul className="header-menu">
            <li
              data-testid="header-memu-item-payment"
              className={`header-menu-items ${activeTab === DashboardRoutesList.PAYMENT_ROUTE ? `is-active` : ``}`}
              onClick={() =>
                navigate(
                  `${getMerchantBaseUrl(merchantName)}/${MerchantDefaultRoutes.DASHBOARD_ROUTE}/${
                    DashboardRoutesList.PAYMENT_ROUTE
                  }/${PaymentRoutesList.PAYMENT_LANDING}`,
                )
              }
            >
              <Text alignment="left" tagName="p" variant="body-3" testId="payment-menu-link">
                Payments
              </Text>
            </li>
            {merchantType === 'StandardMerchant' && (
              <li
                data-testid="header-memu-item-virtual-terminal"
                className={`header-menu-items ${
                  activeTab === DashboardRoutesList.VIRTUAL_TERMINAL_ROUTE ? `is-active` : ``
                }`}
                onClick={() =>
                  navigate(
                    `${getMerchantBaseUrl(merchantName)}/${MerchantDefaultRoutes.DASHBOARD_ROUTE}/${
                      DashboardRoutesList.VIRTUAL_TERMINAL_ROUTE
                    }/${VirtualTerminalRoutesList.VIRTUAL_TERMINAL_LANDING}`,
                  )
                }
              >
                <Text alignment="center" tagName="p" variant="body-3" testId="merchant-menu-link">
                  Virtual Terminal
                </Text>
              </li>
            )}
            <li
              data-testid="header-memu-item-balances"
              className={`header-menu-items ${activeTab === DashboardRoutesList.PAYOUT_ROUTE ? `is-active` : ``}`}
              onClick={() =>
                navigate(
                  `${getMerchantBaseUrl(merchantName)}/${MerchantDefaultRoutes.DASHBOARD_ROUTE}/${
                    DashboardRoutesList.PAYOUT_ROUTE
                  }/${PayoutRoutesList.PAYOUT_LANDING}`,
                )
              }
            >
              <Text alignment="center" tagName="p" variant="body-3" testId="merchant-menu-link">
                Balances
              </Text>
            </li>
            {/* <li className={`header-menu-items ${activeTab === `overview` ? `is-active` : ``}`}>
              <Text alignment="center" tagName="p" variant="body-3" testId="merchant-menu-link">
                Overview
              </Text>
            </li> */}
          </ul>
        </div>
        <ul className="header-main-action">
          {/* TODO: search
          <li
            className={`header-menu-items p-0 ${activeTab === `search` ? `is-active` : ``}`}
            onClick={showZendeskWidget}
          >
            <span>
              <Icon name="Search" />
            </span>
          </li> */}
          <li
            className={`header-menu-items p-0 ${activeTab === `help` ? `is-active` : ``}`}
            onClick={showZendeskWidget}
          >
            <span>
              <Icon name="Help" />
            </span>
          </li>
          {/* <li
            className={`header-menu-items p-0 ${activeTab === `settings` ? `is-active` : ``}`}
            onClick={() =>
              navigate(
                `${getPlatformBaseUrl(platformName)}/dashboard/${DashboardRoutesList.SETTINGS_ROUTE}/${
                  SettingRoutesList.SETTINGS_BRANDING
                }`,
              )
            }
          >
            <span>
              <Icon name="Settings" />
            </span>
          </li> */}
          <li
            className={`header-menu-items p-0 ${activeTab === `settings` ? `is-active` : ``}`}
            onClick={toggleSetting}
          >
            <span>
              <Icon name="Settings" />
            </span>
          </li>
        </ul>
        <ToggleSidebar activeTab={activeTab} />

        {/* Setting Dropdown */}
        {isSettingOpened && (
          <div className="setting-dropdown">
            <SettingsDropdown onCloseSettingClick={toggleSetting} />
          </div>
        )}
      </div>
    </div>
  );
}

export default Header;
